import React, {useState} from 'react';
import {
  Switch,
  Route,
  HashRouter
} from 'react-router-dom';
import logo from './images/AKPortal.svg';
import Step0 from "./Step0";
import Step1 from "./Step1";
import Step2a from "./Step2a";
import Step2b from "./Step2b";
import Step2c from "./Step2c";
import Step2d from "./Step2d";
import Step3 from "./Step3";

// todo: scroll on router things https://reactrouter.com/web/guides/scroll-restoration

function App() {
  const [persons, setPersons] = useState<string[]>([]);
  const [pSNr, setPSNr] = useState<{[key: number]: number}>({
    '4': 1,
    '5': 1,
    '6': 1,
    '7': 1,
    '8': 1,
    '9': 1,
    '10': 1,

    '12': 1,
    '13': 1,
    '14': 1,
    '15': 1,
    '16': 1,

    '18': 1,
    '19': 1,
    '20': 1,
    '21': 1,
  });
  const [s, setS] = useState<{[key: string]: string[]}>({
    '4': ['-', '-', '-', '-'],
    '5': ['-', '-', '-', '-'],
    '6': ['-', '-', '-', '-'],
    '7': ['-', '-', '-', '-'],
    '8': ['-', '-', '-', '-'],
    '9': ['-', '-', '-', '-'],
    '10': ['-', '-', '-', '-'],

    '12': ['-', '-', '-', '-'],
    '13': ['-', '-', '-', '-'],
    '14': ['-', '-', '-', '-'],
    '15': ['-', '-', '-', '-'],
    '16': ['-', '-', '-', '-'],

    '18': ['-', '-', '-', '-'],
    '19': ['-', '-', '-', '-'],
    '20': ['-', '-', '-', '-'],
    '21': ['-', '-', '-', '-'],
  });

  const [inp, setInp] = useState<{[key: string]: string}>({
    '23': 'no',
    '24': 'no',
    '25': 'no',
    '26': 'no',
    '27': 'no',
  });

  return (
    <HashRouter>
      <div className="App">
        <section id="top-bar">
          <div className="container">
            <div className="row">
              <div className="logo col-sm-6">
                <a href="https://arbeiterkammer.at" target="_blank" rel="noreferrer">
                  <img className="rechnerLogo" src={logo} alt="AK Portal" width="234" height="41" />
                </a>
              </div>
              <div className="headerTeaser col-sm-6 hidden-xs">
                <span>VᴇʀA</span>Verantwortung und Algorithmen
              </div>
            </div>
          </div>
        </section>

        <section id="content">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="mainContent floating-label">
                  <Switch>
                    <Route path="/step1">
                      <Step1 persons={persons} setPersons={setPersons} />
                    </Route>
                    <Route path="/step2a">
                      <Step2a persons={persons} setPersons={setPersons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} setInp={setInp} />
                    </Route>
                    <Route path="/step2b">
                      <Step2b persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
                    </Route>
                    <Route path="/step2c">
                      <Step2c persons={persons} pSNr={pSNr} setPSNr={setPSNr} s={s} setS={setS} />
                    </Route>
                    <Route path="/step2d">
                      <Step2d s={s} setS={setS} inp={inp} setInp={setInp} />
                    </Route>
                    <Route path="/step3">
                      <Step3 s={s} setS={setS} inp={inp} />
                    </Route>
                    <Route path="/">
                      <Step0 />
                    </Route>
                  </Switch>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="footer">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <p>© 2021 Bundesarbeiterkammer (BAK)</p>
                <p><a href="https://www.arbeiterkammer.at/impressum.html" target="_blank" rel="noreferrer">Impressum</a></p>
                <p><a href="https://www.arbeiterkammer.at/datenschutz.html" target="_blank" rel="noreferrer">Datenschutzerklärung DVR:
                  0063673</a></p>
                <p>Stand: März 2021</p>
                <div className="sr-only">Technische Umsetzung: <a href="https://petergrassberger.at/" target="_blank" rel="noreferrer">Peter Grassberger</a></div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </HashRouter>
  );
}

export default App;
